import React from "react";
import style from "./Description.module.css";
import Image from "./shared/Image";
import Markdown from 'markdown-to-jsx';

export default function Description({ image, name, description, id, sku }) {
  return (
    <div className={style.root}>
      <Image
        src={image}
        alt="product"
        style={{ width: "600px" }}
        className={style.image}
      />

      <div className={style.info}>
        <h1 className={style.productName}>{name}</h1>

        <ul className="list-unstyled text-muted small">
          <li>SKU: {sku}</li>
          <li>ID: {id}</li>
        </ul>

        <div className="std"><Markdown>{description}</Markdown></div>
      </div>
    </div>
  );
}
